export enum RewriteStringField {
  Omidpn = 'source.ext.omidpn',
  Omidpv = 'source.ext.omidpv',
}

export const rewriteFields = [
  'app.id',
  'app.bundle',
  'app.name',
  'app.store.url',
  'app.inventorypartnerdomain',
  'site.id',
  'site.name',
  'site.domain',
  'site.inventorypartnerdomain',
  'user.ext.consent',
  'user.ext.us_privacy',
  'imp.video.mimes',
  'imp.video.h',
  'imp.video.w',
  'imp.video.maxduration',
  'imp.video.minduration',
  'imp.video.minbitrate',
  'imp.video.maxbitrate',
  'imp.video.delivery',
  'imp.video.linearity',
  'imp.video.protocols',
  'imp.video.playbackmethod',
  'imp.video.startdelay',
  'imp.video.skip',
  'imp.video.skipafter',
  'imp.video.pos',
  'imp.video.placement',
  'imp.video.plcmt',
  'imp.instl',
  'device.ifa',
  'device.type',
  'content.id',
  'content.episode',
  'content.title',
  'content.series',
  'channel.name',
  'channel.id',
  'channel.domain',
  'channel.ext',
  'content.season',
  'content.artist',
  'content.album',
  'content.isrc',
  'producer.id',
  'producer.name',
  'producer.cattax',
  'producer.cat',
  'producer.domain',
  'producer.ext',
  'content.url',
  'content.genre',
  'content.cat',
  'content.prodq',
  'content.context',
  'content.contentrating',
  'content.userrating',
  'content.qagmediarating',
  'content.keywords',
  'content.kwarray',
  'content.livestream',
  'content.sourcerelationship',
  'content.len',
  'content.language',
  'content.langb',
  'content.embeddable',
  'content.data',
  'network.id',
  'network.name',
  'network.domain',
  'network.ext',
  'content.ext',
  'regs.ext.gdpr',
  'regs.ext.usprivacy',
  'imp.tagId',
  'imp.bidfloor',
  'imp.displaymanager',
  'imp.displaymanagerver',
  'imps.ext.hb',
  'publisher.id',
  'publisher.domain',
  'source.schain',
  'source.pchain',
  'source.fd',
  RewriteStringField.Omidpn,
  RewriteStringField.Omidpv,
] as const;
